module.exports = __webpack_public_path__ + "img/search-grey.f6e1f7ed.svg";